var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_566_8548)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_566_8548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 46,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3212 3.65967H0.298828V42.937H45.3212V3.65967Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_566_8548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3001 15.6193C33.4794 15.1503 32.4242 15.1503 31.4862 15.6193L24.9204 19.4884L20.4651 21.9506L14.0166 25.8197C13.1958 26.2886 12.1406 26.2886 11.2027 25.8197L6.16112 22.7712C5.3404 22.3023 4.75417 21.3643 4.75417 20.3091V14.4468C4.75417 13.5089 5.22315 12.5709 6.16112 11.9846L11.2027 9.05352C12.0234 8.58453 13.0786 8.58453 14.0166 9.05352L19.0581 12.1019C19.8789 12.5709 20.4651 13.5089 20.4651 14.564V18.4332L24.9204 15.8538V11.8674C24.9204 10.9295 24.4515 9.99148 23.5135 9.40526L14.1338 3.89471C13.3131 3.42572 12.2579 3.42572 11.32 3.89471L1.70578 9.5225C0.767811 9.99148 0.298828 10.9295 0.298828 11.8674V22.8885C0.298828 23.8265 0.767811 24.7644 1.70578 25.3507L11.2027 30.8612C12.0234 31.3303 13.0786 31.3303 14.0166 30.8612L20.4651 27.1094L24.9204 24.53L31.369 20.7781C32.1897 20.3091 33.2449 20.3091 34.1829 20.7781L39.2244 23.7092C40.0451 24.1782 40.6314 25.1162 40.6314 26.1714V32.0337C40.6314 32.9717 40.1624 33.9096 39.2244 34.4958L34.3001 37.427C33.4794 37.896 32.4242 37.896 31.4862 37.427L26.4447 34.4958C25.6239 34.0269 25.0377 33.0889 25.0377 32.0337V28.2818L20.5824 30.8612V34.7303C20.5824 35.6683 21.0513 36.6063 21.9893 37.1925L31.4862 42.703C32.3069 43.1721 33.3621 43.1721 34.3001 42.703L43.797 37.1925C44.6177 36.7235 45.204 35.7855 45.204 34.7303V23.592C45.204 22.654 44.735 21.716 43.797 21.1298L34.3001 15.6193Z",
    fill: "#8247E5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_566_8548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.1076,
    height: 45.1076,
    fill: "white",
    transform: "translate(0.250977 0.745117)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.dfd0f49e619ef8943bcb58bb4542fbec.svg";
export { ForwardRef as ReactComponent };